// Copyright (c) Docugami, Inc. All rights reserved.
import { SET_SETTINGS_PANEL_SHOWING } from "./types";
import { SettingsState } from "./types";

const initialState: SettingsState = {
    settingsPanelShowing: false,
};

export function settingsReducer(
    state = initialState,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    action: any
): SettingsState
{
    switch (action.type)
    {
        case SET_SETTINGS_PANEL_SHOWING:
        {
            return {
                ...state,
                settingsPanelShowing: action.payload
            }
        }

        default:
            return state;
    }
}
